type Props = {
    width?: number | string;
    height?: number | string;
    className?: string;
    style?: React.CSSProperties;
    direction?: 'expand' | 'collapse';
};

export function DoubleArrowIcon({
    width = 18,
    height = 18,
    className,
    style,
    direction = 'expand',
}: Props) {
    const flip = direction === 'collapse';

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 18 18"
            fill="none"
            className={className}
            style={style}
        >
            <g transform={flip ? 'rotate(180 13.59 4.41)' : undefined}>
                <path
                    d="M10.5 2.25C10.5 2.76777 10.9197 3.1875 11.4375 3.1875H13.4867L10.5 6.17418C10.1339 6.54029 10.1339 7.13388 10.5 7.5C10.8661 7.86612 11.4597 7.86612 11.8258 7.5L14.8125 4.51333V6.5625C14.8125 7.08027 15.2322 7.5 15.75 7.5C16.2678 7.5 16.6875 7.08027 16.6875 6.5625V2.25C16.6875 1.73223 16.2678 1.3125 15.75 1.3125H11.4375C10.9197 1.3125 10.5 1.73223 10.5 2.25Z"
                    fill="white"
                />
            </g>
            <g transform={flip ? 'rotate(180 4.41 13.59)' : undefined}>
                <path
                    d="M7.49999 15.75C7.49999 15.2322 7.08026 14.8125 6.56249 14.8125H4.51332L7.49999 11.8258C7.86611 11.4597 7.86611 10.8661 7.49999 10.5C7.13387 10.1339 6.54028 10.1339 6.17416 10.5L3.1875 13.4867V11.4375C3.1875 10.9197 2.76777 10.5 2.25 10.5C1.73223 10.5 1.3125 10.9197 1.3125 11.4375V15.75C1.3125 16.2678 1.73223 16.6875 2.25 16.6875H6.56249C7.08026 16.6875 7.49999 16.2678 7.49999 15.75Z"
                    fill="white"
                />
            </g>
        </svg>
    );
}

export default DoubleArrowIcon;